import { number, object, string } from 'yup'
import { CONNECTION_SHORT_NAME_MAX_LENGTH } from '../../connections/utils/shortNames'

export const shearConnectionSchema = object({
  guid: string().default(''),
  name: string().required().default(''),
  short_name: string()
    .trim()
    .required('Bitte eine Kurzbezeichnung angeben')
    .max(CONNECTION_SHORT_NAME_MAX_LENGTH, `Höchstens ${CONNECTION_SHORT_NAME_MAX_LENGTH} Zeichen`)
    .default(''),
  export_comment: string().default(''),
  // The installation spacing in m.
  distance: number().moreThan(0).default(1),
  // Stored in N; the form fields convert from the kN the user types.
  r_d_earthquake: number().moreThan(0).default(1000),
  r_d_wind: number().moreThan(0).default(1000),
})

/** `shearConnectionSchema`, rejecting the short names other Schubverbinder already use. */
export const makeShearConnectionSchema = (takenShortNames: string[]) =>
  shearConnectionSchema.shape({
    short_name: shearConnectionSchema.fields.short_name.notOneOf(
      takenShortNames,
      'Diese Kurzbezeichnung wird bereits verwendet',
    ),
  })
